import { Component, OnInit } from '@angular/core';
import { CrudService } from '../crud.service';
@Component({
  selector: 'app-building-maintenance-purchase-committee',
  templateUrl: './building-maintenance-purchase-committee.component.html',
  styleUrls: ['./building-maintenance-purchase-committee.component.scss']
})
export class BuildingMaintenancePurchaseCommitteeComponent implements OnInit {

  constructor(private crudService: CrudService) { }
  baseUrl = this.crudService.baseUrl;


  ngOnInit(): void {
  }

}
